export default __webpack_public_path__ + "static/img-project-3-45244327ada6b0d97dc455ba49e09c9b.png";